module.exports = __webpack_public_path__ + "img/en-US.b7534e89.png";